import React from 'react';
import { IconProps } from '.';

const SvgArrowChevronDoubleLeft = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path stroke={color} strokeWidth={1.5} d='m12.5 4-8 8 8 8' />
      <path stroke={color} strokeWidth={1.5} d='m19.5 4-8 8 8 8' />
      <path fill={color} d='m13.03 4.53-1.06-1.06L3.44 12l8.53 8.53 1.06-1.06L5.56 12l7.47-7.47Z' />
      <path fill={color} d='m20.03 4.53-1.06-1.06L10.44 12l8.53 8.53 1.06-1.06L12.56 12l7.47-7.47Z' />
    </svg>
  );
};

export default SvgArrowChevronDoubleLeft;
